import React from 'react';
import { getSurfaceLabel } from '../utils/mapHelpers';

function ResultsPanel({
                          routeData,
                          alternativeRouteData,
                          onClose,
                          onStandardRouteHover,
                          onAlternativeRouteHover
                      }) {
    // Fonction helper pour formater la durée
    const formatDuration = (minutes) => {
        if (!minutes) return null;
        const hours = Math.floor(minutes / 60);
        const mins = minutes % 60;

        if (hours > 0) {
            return mins > 0 ? `${hours}h ${mins}min` : `${hours}h`;
        }
        return `${mins}min`;
    };

    return (
        <div
            style={{
                position: 'absolute',
                top: '80px',
                right: '20px',
                width: '300px',
                maxHeight: 'calc(100vh - 100px)',
                overflow: 'auto',
                backgroundColor: 'white',
                borderRadius: '12px',
                boxShadow: '0 4px 20px rgba(0,0,0,0.3)',
                zIndex: 1000,
            }}
        >
            <div style={{ padding: '15px' }}>
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginBottom: '15px',
                    }}
                >
                    <h3 style={{ margin: 0, fontSize: '16px' }}>📊 Résultats</h3>
                    <button
                        onClick={onClose}
                        style={{
                            background: 'none',
                            border: 'none',
                            fontSize: '18px',
                            cursor: 'pointer',
                        }}
                    >
                        ✕
                    </button>
                </div>

                {/* Route standard */}
                {routeData && (
                    <div
                        onMouseEnter={() => onStandardRouteHover && onStandardRouteHover(true)}
                        onMouseLeave={() => onStandardRouteHover && onStandardRouteHover(false)}
                        style={{
                            marginBottom: '15px',
                            padding: '12px',
                            backgroundColor: '#f8f9fa',
                            borderRadius: '8px',
                            cursor: 'pointer',
                            transition: 'all 0.2s ease',
                            border: '2px solid transparent',
                        }}
                        onMouseOver={(e) => {
                            e.currentTarget.style.backgroundColor = '#e3f2fd';
                            e.currentTarget.style.borderColor = '#2196f3';
                            e.currentTarget.style.transform = 'scale(1.02)';
                        }}
                        onMouseOut={(e) => {
                            e.currentTarget.style.backgroundColor = '#f8f9fa';
                            e.currentTarget.style.borderColor = 'transparent';
                            e.currentTarget.style.transform = 'scale(1)';
                        }}
                    >
                        <h4 style={{ margin: '0 0 8px 0', fontSize: '14px', color: '#2196f3' }}>
                            🔵 Route standard
                        </h4>
                        <p style={{ margin: '5px 0', fontSize: '13px' }}>
                            <strong>{routeData.distance} km</strong>
                        </p>
                        {/* AJOUT DE LA DURÉE */}
                        {routeData.duration && (
                            <p style={{ margin: '5px 0', fontSize: '13px', color: '#666' }}>
                                ⏱️ {formatDuration(routeData.duration)}
                            </p>
                        )}
                        <div style={{ fontSize: '11px', marginTop: '8px' }}>
                            {Object.entries(routeData.surfaces)
                                .filter(([s]) => s !== 'unknown' && s !== 'missing')
                                .sort(([, a], [, b]) => parseFloat(b.percentage) - parseFloat(a.percentage))
                                .slice(0, 3)
                                .map(([surface, data]) => (
                                    <div key={surface} style={{ margin: '3px 0' }}>
                                        {getSurfaceLabel(surface)}: {data.percentage}%
                                    </div>
                                ))}
                        </div>
                        <div style={{
                            fontSize: '10px',
                            color: '#666',
                            marginTop: '8px',
                            fontStyle: 'italic'
                        }}>
                            💡 Survolez pour voir sur la carte
                        </div>
                    </div>
                )}

                {/* Route alternative */}
                {alternativeRouteData && (
                    <div
                        onMouseEnter={() => onAlternativeRouteHover && onAlternativeRouteHover(true)}
                        onMouseLeave={() => onAlternativeRouteHover && onAlternativeRouteHover(false)}
                        style={{
                            padding: '12px',
                            backgroundColor: '#f1f8f4',
                            borderRadius: '8px',
                            border: '2px solid transparent',
                            cursor: 'pointer',
                            transition: 'all 0.2s ease',
                        }}
                        onMouseOver={(e) => {
                            e.currentTarget.style.backgroundColor = '#d1f4e0';
                            e.currentTarget.style.borderColor = '#10b981';
                            e.currentTarget.style.transform = 'scale(1.02)';
                        }}
                        onMouseOut={(e) => {
                            e.currentTarget.style.backgroundColor = '#f1f8f4';
                            e.currentTarget.style.borderColor = 'transparent';
                            e.currentTarget.style.transform = 'scale(1)';
                        }}
                    >
                        <h4 style={{ margin: '0 0 8px 0', fontSize: '14px', color: '#10b981' }}>
                            🟢 Route alternative
                        </h4>
                        <p style={{ margin: '5px 0', fontSize: '13px' }}>
                            <strong>{alternativeRouteData.distance} km</strong>
                        </p>
                        {/* AJOUT DE LA DURÉE */}
                        {alternativeRouteData.duration && (
                            <p style={{ margin: '5px 0', fontSize: '13px', color: '#666' }}>
                                ⏱️ {formatDuration(alternativeRouteData.duration)}
                            </p>
                        )}
                        {routeData && (
                            <>
                                <p style={{ margin: '5px 0', fontSize: '11px', color: '#666' }}>
                                    +{(parseFloat(alternativeRouteData.distance) - parseFloat(routeData.distance)).toFixed(1)} km
                                </p>
                                {/* AJOUT DE LA DIFFÉRENCE DE TEMPS */}
                                {alternativeRouteData.duration && routeData.duration && (
                                    <p style={{ margin: '5px 0', fontSize: '11px', color: '#666' }}>
                                        {alternativeRouteData.duration > routeData.duration ? '+' : ''}{alternativeRouteData.duration - routeData.duration} min
                                    </p>
                                )}
                            </>
                        )}
                        <div style={{ fontSize: '11px', marginTop: '8px' }}>
                            {Object.entries(alternativeRouteData.surfaces)
                                .filter(([s]) => s !== 'unknown' && s !== 'missing')
                                .sort(([, a], [, b]) => parseFloat(b.percentage) - parseFloat(a.percentage))
                                .slice(0, 3)
                                .map(([surface, data]) => (
                                    <div key={surface} style={{ margin: '3px 0' }}>
                                        {getSurfaceLabel(surface)}: {data.percentage}%
                                    </div>
                                ))}
                        </div>
                        <div style={{
                            fontSize: '10px',
                            color: '#666',
                            marginTop: '8px',
                            fontStyle: 'italic'
                        }}>
                            💡 Survolez pour voir sur la carte
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}

export default ResultsPanel;